// Small read-only chip showing the `RussiaRequestType` of a row. Color
// is informational only; the wire enum is the source of truth. All
// surfaces use CSS tokens — no hardcoded hex.

import { useTranslation } from 'react-i18next';
import { RussiaRequestType } from '@magimp/shared';

const TYPE_LABEL_KEYS = {
  [RussiaRequestType.LEAD]: 'types.lead',
  [RussiaRequestType.WAREHOUSE]: 'types.warehouse',
  [RussiaRequestType.IN_TRANSIT]: 'types.inTransit',
  [RussiaRequestType.URGENT]: 'types.urgent',
} as const satisfies Record<RussiaRequestType, string>;

const TYPE_TONE: Record<RussiaRequestType, { bg: string; fg: string }> = {
  [RussiaRequestType.LEAD]: { bg: 'var(--status-info-bg)', fg: 'var(--status-info-fg)' },
  [RussiaRequestType.WAREHOUSE]: { bg: 'var(--bg-2)', fg: 'var(--fg-2)' },
  [RussiaRequestType.IN_TRANSIT]: {
    bg: 'var(--status-success-bg)',
    fg: 'var(--status-success-fg)',
  },
  [RussiaRequestType.URGENT]: { bg: 'var(--status-error-bg)', fg: 'var(--status-error-fg)' },
};

export function RussiaRequestTypeChip({ type }: { type: RussiaRequestType }) {
  const { t } = useTranslation('russiaRequests');
  const tone = TYPE_TONE[type];
  return (
    <span
      style={{
        display: 'inline-block',
        padding: '2px 8px',
        borderRadius: 'var(--r-1)',
        fontSize: 12,
        lineHeight: '16px',
        background: tone.bg,
        color: tone.fg,
        whiteSpace: 'nowrap',
      }}
      data-testid={`russia-request-type-${type.toLowerCase()}`}
    >
      {t(TYPE_LABEL_KEYS[type])}
    </span>
  );
}
